import { HeroSection } from "@/components/home/HeroSection";
import { MergeAnimation } from "@/components/home/MergeAnimation";
import { LeistungenSection } from "@/components/home/LeistungenSection";
import { WarumSection } from "@/components/home/WarumSection";
import { UeberUnsSection } from "@/components/home/UeberUnsSection";
import { ProjektePreview } from "@/components/home/ProjektePreview";
import { ProzessSection } from "@/components/home/ProzessSection";
import { TestimonialsSection } from "@/components/home/TestimonialsSection";
import { MapSection } from "@/components/home/MapSection";
import { CTASection } from "@/components/home/CTASection";
import { SEOHead } from "@/components/shared/SEOHead";

export default function HomePage() {
  return (
    <div>
      <SEOHead
        title="Freitag-Gruppe Braunschweig | Bauunternehmung, Galabau & Sachverständiger"
        description="Die Freitag-Gruppe aus Braunschweig vereint Bausanierung, Tiefbau, Garten- und Landschaftsbau sowie Sachverständigenbüro unter einem Dach. Über 25 Jahre Erfahrung. 4.9 Sterne auf Google."
        canonical="/"
        schemaKey="home"
      />
      <HeroSection />
      <MergeAnimation />
      <LeistungenSection />
      <WarumSection />
      <UeberUnsSection />
      <ProjektePreview />
      <ProzessSection />
      <TestimonialsSection />
      <MapSection />
      <CTASection />
    </div>
  );
}
